import _ from "lodash";
import React, { useState, useEffect, useRef, useCallback } from "react";
import classes from "./EditOrCreateEvent.scss";
import PropTypes from "prop-types";
import { getUserInfo } from "Login/modules/LoginModule/LoginUtils";
import UIModal from "UIComponents/UIModal";
import I18nHOC from "UIComponents/I18nHOC";
import CreateOrEditAssignment from "AppComponents/CreateOrEditAssignment";
import CreateCalendarDeadlineModal from "Projects/components/CreateCalendarDeadlineModal";
import { compose } from "lib/apolloClient";
import ScheduleEvent from "ClassRoom/components/AddAssignment/ScheduleEvent";
import { setPopoverModalContentLocation } from "MyCalendar/modules/MyCalendarModule/MyCalendarUtils";
import {
  MYP_ASSIGNMENT_OPTIONS_NEW,
  ASSIGNMENT_CREATE_OPTIONS_NEW,
  UBD_ASSIGNMENT_OPTIONS_NEW,
  DP_ASSIGNMENT_OPTIONS_NEW,
  getDropdownOptions as getOptionsForDropdown,
  SCHOOL_CALENDAR_EVENT_CREATE_OPTION,
} from "ClassRoom/modules/ClassRoomModule";
import {
  CURRICULUM_TYPE_MYP,
  CURRICULUM_TYPE_UBD,
  CURRICULUM_TYPE_DP,
  CREATE,
  SUBJECT_TYPE_EE,
  SUBJECT_TYPE_CAS,
  CREATE_AI_TUTOR,
} from "Constants/stringConstants";
import { connect } from "react-redux";
import { Dropdown, DropdownMenu, DSProvider } from "@toddle-edu/ds-web";
import { VideoOutlined } from "@toddle-edu/ds-icons";
import EventCreationModal from "MyCalendar/components/EventCreationModal";
import classNames from "classnames";
import { MY_CALENDAR_CONSTANTS } from "MyCalendar/constants/stringConstants";
import {
  getOptionsList,
  isStaffAdminForProjectModules,
  filterCreateOptionsOnCalendarByPermission,
  isNewEventCreationFlowEnabled,
  isStaffAdminForSchoolCalendarByContext,
  // getMonthCellHeight,
  getOptionsListHavingSchoolEventOnTopOnFFEnable,
  canUserCreateEventOnCalendar,
  getSelectedAcademicYearForSchool,
} from "MyCalendar/modules/Utils";
import { getFilteredEventCreationPopupListOptions } from "MyCalendar/components/EventModalV2/modules/Utils";
import {
  getProjectGroups,
  getFilteredEventTypes,
  getCurrentCurriculumProgramType,
} from "MyCalendar/modules/Selector";
import { resetEventModalV2 } from "MyCalendar/modules/MyCalendarModule";
import moment from "moment";

import { getIsAITutorInEEEnabled } from "Utils/ACLStoreUtils";
import {
  isDateInBetween,
  getNextThirtyMinuteSlot,
} from "Utils/DateTimeHelpers";
import {
  getFilteredCoursesBasedOnViewOrManagePermission,
  getAssignmentDropdownOptions,
} from "ClassRoom/modules/utils";
import {
  getSelectedAcademicYearStartDate,
  getSelectedAcademicYearEndDate,
  getUserCurriculumPrograms,
} from "modules/CommonSelectors";
import {
  setAiModuleMarketingKey,
  setupCurriculumProgramDependencies,
} from "Platform/modules/PlatformModule";
import { isToddleLibraryEnabledForWorksheets } from "Worksheet/modules/WorksheetUtils";
import { getGradeBasicDetailsFromCache } from "modules/CommonGraphqlHelpers";
import { getProjectGroupCategoryIdByType } from "Projects/modules/Utils";

import ACLStore from "lib/aclStore";
import {
  isAITutorMarketingEnabled,
  getIsCombineCurriculumHomePageEnabled,
} from "Platform/modules/PlatformUtils";
import { AI_MODULES_FOR_MARKETING } from "Login/components/ChildrenPage/components/AIModuleMarketingModal/AIModuleMarketingUtils";
import { ASSIGNMENTS_MANAGE_PERMISSION_IN_CALENDAR } from "Constants/permissionConstants";
import { getIsLearningCoursesEnabled } from "LearningCourses/modules/Utils";
import { EventCreationModalV2 } from "../EventModalV2";
import {
  Popover,
  //  ArrowContainer
} from "@toddle-edu/react-tiny-popover";
import ConformationModal from "../EventModalV2/components/ConfirmationModal";
import {
  ASSIGNMENT_CREATE_OPTIONS_NEW_V2,
  DP_ASSIGNMENT_OPTIONS_NEW_V2,
  MYP_ASSIGNMENT_OPTIONS_NEW_V2,
  UBD_ASSIGNMENT_OPTIONS_NEW_V2,
} from "../../modules/MyCalendarModule/MyCalendarConstants";
import {
  useIsEventFormUpdated,
  useIsVideoMeetingFormUpdated,
} from "../EventModalV2/hooks";
import VideoMeetingCreationModal from "../EventModalV2/components/VideoMeetingCreationModal";
import { isNewVideoMeetingUIFeatureEnabled } from "../EventModalV2/modules/Utils";
import { getSelectedSchoolDetailsForCalendar } from "../../modules/Utils";

const initialEventCreationModalObj = {
  isVisible: false,
  eventType: null,
  action: null,
};

const getFilteredOptionsBasedOnModuleSetting = curriculumWiseOptions => {
  return _.reduce(
    curriculumWiseOptions,
    (filteredOptions, option) => {
      const { key, options } = option || {};
      if (key !== "Assign") {
        filteredOptions.push({
          ...option,
          options: _.filter(
            options,
            ({ key }) => key === "SCHEDULE_VIDEO_CALL"
          ),
        });
      }
      return filteredOptions;
    },
    []
  );
};

const shouldRestrictAssignmentCreation = ({
  preSelectedCourseIds,
  courseList,
}) => {
  const filteredCourses = getFilteredCoursesBasedOnViewOrManagePermission({
    courses: courseList,
    permissionsToCheck: [ASSIGNMENTS_MANAGE_PERMISSION_IN_CALENDAR],
  });
  return _.every(preSelectedCourseIds, courseId =>
    _.isEmpty(_.find(filteredCourses, { courseId }))
  );
};

const getFilteredOptionsBasedOnNewCourseSetup = (
  curriculumWiseOptions,
  curriculumProgramId
) => {
  const isLearningCoursesEnabled = getIsLearningCoursesEnabled({
    curriculumProgramId,
  });

  if (!isLearningCoursesEnabled) {
    return curriculumWiseOptions;
  }

  return _.reduce(
    curriculumWiseOptions,
    (filteredOptions, option) => {
      const { key, options } = option || {};
      if (key === "Assign") {
        filteredOptions.push({
          ...option,
          options: _.filter(
            options,
            ({ key }) => !_.includes(["IMPORT_LE", "UNIT"], key)
          ),
        });
      } else {
        filteredOptions.push(option);
      }
      return filteredOptions;
    },
    []
  );
};

const getDynamicOptions = _.memoize(
  ({
    curriculumProgramType,
    subjectType,
    isCASOrEESelected,
    globalGradeUid,
    preSelectedCourseIds,
    courseList,
    curriculumProgramId,
    isCalendarOpenedFromHome,
    isCalendarDailyView,
  }) => {
    const restrictAssignmentCreation = shouldRestrictAssignmentCreation({
      preSelectedCourseIds,
      courseList,
    });

    // Get options from getAssignmentDropdownOptions
    let options = getAssignmentDropdownOptions({
      curriculumType: curriculumProgramType,
      globalGradeUid,
      filterOptions: [],
      curriculumId: curriculumProgramId,
    });

    // Add video meeting option at the top of the create options
    options = _.map(options, option => {
      if (_.get(option, "key") === "create") {
        const innerOptions = _.get(option, "options", []);
        const hasVideoCallOption = _.some(
          innerOptions,
          innerOption => _.get(innerOption, "key") === "SCHEDULE_VIDEO_CALL"
        );

        if (!hasVideoCallOption) {
          return {
            ...option,
            options: [
              {
                label: "common:video_meeting_lower",
                key: "SCHEDULE_VIDEO_CALL",
                icon: <VideoOutlined variant={"subtle"} />,
                hasTermDependency: false,
              },
              {
                label: "",
                key: "",
                icon: null,
                hasTermDependency: false,
                isDivider: true,
              },
              ...innerOptions,
            ],
          };
        }
      }

      return option;
    });

    // If assignment creation is restricted, filter to only show schedule video call
    if (restrictAssignmentCreation) {
      options = getFilteredOptionsBasedOnModuleSetting(options);
    }

    // For DP curriculum with CAS or EE subjects, filter options
    if (
      _.isEqual(curriculumProgramType, CURRICULUM_TYPE_DP) &&
      (_.includes([SUBJECT_TYPE_CAS, SUBJECT_TYPE_EE], subjectType) ||
        isCASOrEESelected)
    ) {
      // Filter import from unit and library
      options = _.filter(options, ({ key }) => key !== "Assign");

      // Filter to show only CREATE_QUICK_TASK
      options = _.map(options, option => {
        if (_.get(option, "key") === "create") {
          const filteredOptions = _.filter(
            _.get(option, "options", []),
            ({ taskType }) => taskType === "QUICK_TASK"
          );

          return {
            ...option,
            options: filteredOptions,
          };
        }

        return option;
      });
    }

    return getOptionsListHavingSchoolEventOnTopOnFFEnable({
      options,
      curriculumProgramId,
      isCalendarOpenedFromHome,
      isCalendarDailyView,
      courseList,
    });
  },

  params => JSON.stringify(params)
);

const getOptions = ({
  curriculumProgramType,
  subjectType,
  isCASOrEESelected,
  globalGradeUid,
  preSelectedCourseIds,
  courseList,
  curriculumProgramId,
  isCalendarOpenedFromHome,
  isCalendarDailyView,
}) => {
  const restrictAssignmentCreation = shouldRestrictAssignmentCreation({
    preSelectedCourseIds,
    courseList,
  });
  const isNewEventCreationFlowFFEnabled = isNewEventCreationFlowEnabled();

  switch (curriculumProgramType) {
    case CURRICULUM_TYPE_UBD:
      if (restrictAssignmentCreation) {
        return getOptionsListHavingSchoolEventOnTopOnFFEnable({
          options: getFilteredOptionsBasedOnModuleSetting(
            isNewEventCreationFlowFFEnabled
              ? UBD_ASSIGNMENT_OPTIONS_NEW_V2
              : UBD_ASSIGNMENT_OPTIONS_NEW
          ),
          curriculumProgramId,
          isCalendarOpenedFromHome,
          isCalendarDailyView,
          courseList,
        });
      }
      return getOptionsListHavingSchoolEventOnTopOnFFEnable({
        options: getFilteredOptionsBasedOnNewCourseSetup(
          isNewEventCreationFlowFFEnabled
            ? UBD_ASSIGNMENT_OPTIONS_NEW_V2
            : UBD_ASSIGNMENT_OPTIONS_NEW,
          curriculumProgramId
        ),
        curriculumProgramId,
        isCalendarOpenedFromHome,
        isCalendarDailyView,
        courseList,
      });

    case CURRICULUM_TYPE_MYP:
      if (restrictAssignmentCreation) {
        return getOptionsListHavingSchoolEventOnTopOnFFEnable({
          options: getFilteredOptionsBasedOnModuleSetting(
            isNewEventCreationFlowFFEnabled
              ? MYP_ASSIGNMENT_OPTIONS_NEW_V2
              : MYP_ASSIGNMENT_OPTIONS_NEW
          ),
          curriculumProgramId,
          isCalendarOpenedFromHome,
          isCalendarDailyView,
          courseList,
        });
      }
      return getOptionsListHavingSchoolEventOnTopOnFFEnable({
        options: getFilteredOptionsBasedOnNewCourseSetup(
          isNewEventCreationFlowFFEnabled
            ? MYP_ASSIGNMENT_OPTIONS_NEW_V2
            : MYP_ASSIGNMENT_OPTIONS_NEW,
          curriculumProgramId
        ),
        curriculumProgramId,
        isCalendarOpenedFromHome,
        isCalendarDailyView,
        courseList,
      });

    case CURRICULUM_TYPE_DP: {
      if (restrictAssignmentCreation) {
        return getOptionsListHavingSchoolEventOnTopOnFFEnable({
          options: getFilteredOptionsBasedOnModuleSetting(
            isNewEventCreationFlowFFEnabled
              ? DP_ASSIGNMENT_OPTIONS_NEW_V2
              : DP_ASSIGNMENT_OPTIONS_NEW
          ),
          curriculumProgramId,
          isCalendarOpenedFromHome,
          isCalendarDailyView,
          courseList,
        });
      }
      let options = getOptionsListHavingSchoolEventOnTopOnFFEnable({
        options: getFilteredOptionsBasedOnNewCourseSetup(
          isNewEventCreationFlowFFEnabled
            ? DP_ASSIGNMENT_OPTIONS_NEW_V2
            : DP_ASSIGNMENT_OPTIONS_NEW,
          curriculumProgramId
        ),
        curriculumProgramId,
        isCalendarOpenedFromHome,
        isCalendarDailyView,
        courseList,
      });

      if (
        !isToddleLibraryEnabledForWorksheets({
          curriculumType: curriculumProgramType,
          globalGradeUid,
        })
      ) {
        const importOptions = _.find(options, { key: "Assign" });
        importOptions.options = _.filter(
          importOptions.options,
          option => option?.key !== "IMPORT_FROM_TODDLE_LIBRARY"
        );
      }

      if (
        _.includes([SUBJECT_TYPE_CAS, SUBJECT_TYPE_EE], subjectType) ||
        isCASOrEESelected
      ) {
        // filter import from unit and library
        options = _.filter(
          DP_ASSIGNMENT_OPTIONS_NEW,
          ({ key }) => key !== "Assign"
        );

        const allowedKeys =
          subjectType === SUBJECT_TYPE_EE && getIsAITutorInEEEnabled()
            ? ["CREATE_QUICK_TASK", CREATE_AI_TUTOR]
            : ["CREATE_QUICK_TASK"];

        // fitler FMT, SMT, LE
        options = _.map(options, option => {
          if (option?.key === "create") {
            const filteredOptions = _.filter(option?.options, ({ key }) =>
              allowedKeys.includes(key)
            );

            return {
              ...option,
              options: filteredOptions,
            };
          }

          return option;
        });
        return options;
      } else {
        return options;
      }
    }
    default:
      if (restrictAssignmentCreation) {
        return getOptionsListHavingSchoolEventOnTopOnFFEnable({
          options: getFilteredOptionsBasedOnModuleSetting(
            isNewEventCreationFlowFFEnabled
              ? ASSIGNMENT_CREATE_OPTIONS_NEW_V2
              : ASSIGNMENT_CREATE_OPTIONS_NEW
          ),
          curriculumProgramId,
          isCalendarOpenedFromHome,
          isCalendarDailyView,
          courseList,
        });
      }
      return getOptionsListHavingSchoolEventOnTopOnFFEnable({
        options: isNewEventCreationFlowFFEnabled
          ? ASSIGNMENT_CREATE_OPTIONS_NEW_V2
          : ASSIGNMENT_CREATE_OPTIONS_NEW,
        curriculumProgramId,
        isCalendarOpenedFromHome,
        isCalendarDailyView,
        courseList,
      });
  }
};

const EditOrCreateEvent = React.memo(props => {
  const {
    mode,
    courseId,
    academicYearId,
    course,
    courseList,
    showOverlay,
    showDropdown,
    refetchEvents,
    refetchAssignedData,
    refetchRotationDays,
    buttonComponent,
    selectedTimeSlot,
    onOverlayClickClose,
    calendarEventModalClose,
    btnDropdownStyles,
    editModeDetails,
    popoverProps,
    preSelectedCourseIds,
    curriculumProgramType,
    t,
    pageName,
    emptyStateCreate,
    subjectType,
    isCASOrEESelected,
    projectGroups,
    isCalendarOpenedFromHome,
    isCalendarDeadlineView,
    calendarView,
    getOptionsForDropdown,
    globalGradeUid,
    isUpcomingAcademicYear,
    isDpCurriculum,
    testId,
    selectedAcademicYearStartDate,
    selectedAcademicYearEndDate,
    openedFromHeader,
    projectGroupCategoryIdByType,
    curriculumProgramId,
    slotDropdown,
    setSlotDropdown,
    createEventContainerClass = "",
    eventTypeList,
    resetEventModalV2,
    slotId,
    setupCurriculumProgramDependencies,
    userCurriculumPrograms,
  } = props;

  const isWeeklyView = calendarView === "week";
  const isNewEventCreationFlowFFEnabled = isNewEventCreationFlowEnabled();

  const isGlobalHeaderEnabled = ACLStore.can("FeatureFlag:EnableGlobalHeader");

  const isAssessmentTypeConfigurationEnabled = ACLStore.can(
    "FeatureFlag:AssessmentTypeConfiguration"
  );

  const isCalendarDailyView = pageName === MY_CALENDAR_CONSTANTS.DAILY_VIEW;

  const [assignmentModalData, setAssignmentModalData] = useState({});
  const [showScheduleEventModal, setScheduleEventModal] = useState(false);
  const preselectedCoursesLength = _.size(preSelectedCourseIds);
  const [selectedSlotClicked, setSelectedSlotClicked] = useState(false);
  const [showEventCreationModal, setShowEventCreationModal] = useState(
    initialEventCreationModalObj
  );
  const [showNewDeadlineModal, setShowNewDeadlineModal] = useState(false);

  const dropdownButtonRef = useRef(null);

  const optionsToExcludeInCalendar =
    preselectedCoursesLength == 1
      ? ["IMPORT_LE_FROM_COMMUNITY"]
      : ["IMPORT_LE_FROM_COMMUNITY", "IMPORT_LE_FROM_LE_LIBRARY"];

  const selectedSlotClasses = classNames({
    [classes.selectedSlot]: !emptyStateCreate,
    // "text-label-s": !emptyStateCreate && isNewEventCreationFlowFFEnabled,
    // [classes.selectSlotV2]:
    //   !emptyStateCreate && isNewEventCreationFlowFFEnabled,
  });

  const getDropdownOptions = () => {
    const options = filterCreateOptionsOnCalendarByPermission(
      isAssessmentTypeConfigurationEnabled
        ? getDynamicOptions({
            curriculumProgramType,
            subjectType,
            isCASOrEESelected,
            globalGradeUid,
            preSelectedCourseIds,
            courseList,
            curriculumProgramId,
            isCalendarOpenedFromHome,
            isCalendarDailyView,
          })
        : getOptions({
            curriculumProgramType,
            subjectType,
            isCASOrEESelected,
            globalGradeUid,
            preSelectedCourseIds,
            courseList,
            curriculumProgramId,
            isCalendarOpenedFromHome,
            isCalendarDailyView,
          })
    );

    const isSelectedDateInCurrentAcademicYear = isDateInBetween({
      date: _.get(selectedTimeSlot, "startDate"),
      date1: selectedAcademicYearStartDate,
      date2: selectedAcademicYearEndDate,
    });

    const isStaffSchoolCalendarAdmin = isStaffAdminForSchoolCalendarByContext({
      contexts: [
        {
          entityId: curriculumProgramId,
          entityType: "CURRICULUM_PROGRAM",
        },
      ],
    });

    const canUserCreateEvent = canUserCreateEventOnCalendar({
      isStaffSchoolCalendarAdmin,
      currentCurriculumProgramId: curriculumProgramId,
      courseList,
    });

    const optionsList =
      // if it is upcoming academic year we should allow whole day event creation for all curriculums
      isUpcomingAcademicYear
        ? [SCHOOL_CALENDAR_EVENT_CREATE_OPTION]
        : getOptionsList({
            curriculumProgramType,
            options,
            projectGroups,
            courseId,
            isCalendarOpenedFromHome,
            isCalendarDeadlineView,
            isCalendarDailyView,
            subjectType,
            academicYearId,
            isSelectedDateInCurrentAcademicYear,
            projectGroupCategoryIdByType,
            curriculumProgramId,
            canUserCreateEvent,
          });
    const finalPopUpListOptions = getOptionsForDropdown({
      t,
      options: optionsList,
      optionsToExcludeInCalendar,
      skipTermsCheckForLearningCourse: true,
      curriculumType: curriculumProgramType,
      curriculumProgramId,
    });
    return isNewEventCreationFlowFFEnabled
      ? getFilteredEventCreationPopupListOptions(
          finalPopUpListOptions,
          _.isEmpty(eventTypeList)
        )
      : finalPopUpListOptions;
  };

  const clonedOptions = getDropdownOptions();
  const { isVisible, eventType, action } = showEventCreationModal;

  const onCreateEventClick = () => {
    setShowEventCreationModal({
      isVisible: true,
      eventType: MY_CALENDAR_CONSTANTS.SCHOOL_CALENDAR_EVENT,
      action: CREATE,
    });
  };

  const onCreateProjectDeadline = () => {
    setShowEventCreationModal({
      isVisible: true,
      eventType: MY_CALENDAR_CONSTANTS.PROJECT_DEADLINE_EVENT,
      action: CREATE,
    });
  };
  const onCloseEventCreationModal = async () => {
    setShowEventCreationModal(initialEventCreationModalObj);
    if (onOverlayClickClose) {
      onOverlayClickClose();
    }

    if (refetchEvents) {
      await refetchEvents();
    }

    if (refetchAssignedData) {
      await refetchAssignedData();
    }

    if (refetchRotationDays) {
      await refetchRotationDays();
    }
  };

  // * Setting up curriculum program context for CCH while creating assessment from calender
  const setCurriculumProgramContextForCCH = useCallback(() => {
    if (getIsCombineCurriculumHomePageEnabled()) {
      setupCurriculumProgramDependencies({
        curriculumProgramIdPath: curriculumProgramId,
        curriculumPrograms: userCurriculumPrograms,
      });
    }
  }, [
    curriculumProgramId,
    setupCurriculumProgramDependencies,
    userCurriculumPrograms,
  ]);

  const resetCurriculumProgramContextForCCH = useCallback(() => {
    if (getIsCombineCurriculumHomePageEnabled()) {
      setupCurriculumProgramDependencies({});
    }
  }, [setupCurriculumProgramDependencies]);

  /**
   * This function is used to create Steps for Assignment/ Event
   * Only used when mode==='create
   */
  const onDropdownItemClick = async ({ key, id }) => {
    if (_.isEqual(key, CREATE_AI_TUTOR) && isAITutorMarketingEnabled()) {
      props.setAiModuleMarketingKey(AI_MODULES_FOR_MARKETING.AI_TUTOR);
      if (_.isFunction(onOverlayClickClose)) onOverlayClickClose?.();
      return;
    }

    /**
     * If item clicked is create event (school calendar event), call onCreateEventClick and return
     * Because we are showing different modal in that case.
     */

    switch (key) {
      case MY_CALENDAR_CONSTANTS.CREATE_EVENT:
        onCreateEventClick();
        return;
      case MY_CALENDAR_CONSTANTS.CREATE_MYP_PROJECT_DEADLINE:
      case MY_CALENDAR_CONSTANTS.CREATE_DP_CP_DEADLINE:
      case MY_CALENDAR_CONSTANTS.CREATE_DP_DEADLINE:
        onCreateProjectDeadline();
        return;
      case MY_CALENDAR_CONSTANTS.MYP_PROJECT_DEADLINE_NEW:
      case MY_CALENDAR_CONSTANTS.CREATE_DP_CP_DEADLINE_NEW:
      case MY_CALENDAR_CONSTANTS.CREATE_DP_DEADLINE_NEW: {
        setShowNewDeadlineModal(true);
        return;
      }
      case "SCHEDULE_VIDEO_CALL": {
        setScheduleEventModal(true);

        const newAssignmentModalData = {
          mode: "create",
          creationMode: key,
          creationSource: "CALENDAR",
          courseId,
          pageName,
        };
        newAssignmentModalData["steps"] = [
          {
            value: "SCHEDULE_CALL_SETTINGS",
            label: t("common:schedule_video_call"),
          },
        ];
        newAssignmentModalData["contentType"] = "ASSIGNMENT_MEETING";
        newAssignmentModalData["createHeader"] = t(
          "common:schedule_video_call"
        );
        setAssignmentModalData(newAssignmentModalData);
        return;
      }
      default: {
        setCurriculumProgramContextForCCH();
        setAssignmentModalData({
          mode: "create",
          createAssignmentData: { key },
          clonedAssessmentId: id,
        });
        return;
      }
    }
  };

  const onCloseAddAssignmentModal = async () => {
    resetCurriculumProgramContextForCCH();
    setScheduleEventModal(false);
    onOverlayClickClose ? onOverlayClickClose() : null;
    refetchEvents ? await refetchEvents() : null;
    refetchAssignedData ? await refetchAssignedData() : null;
    calendarEventModalClose ? calendarEventModalClose() : null;
  };

  const onCloseVideoMeetingModal = async () => {
    setShowEventCreationModal(initialEventCreationModalObj);
    await onCloseAddAssignmentModal();
  };

  const onCloseAssessmentDraftModal = () => {
    resetCurriculumProgramContextForCCH();
    onOverlayClickClose?.();
  };

  /**
   *  Logic for event edit mode starts here
   */
  const onCalendarItemEdit = ({ eventId }) => {
    const newAssignmentModalData = { eventId, mode: "edit" };
    newAssignmentModalData["steps"] = [
      {
        value: "SCHEDULE_CALL_SETTINGS",
        label: t("common:schedule_video_call"),
      },
    ];
    newAssignmentModalData["contentType"] = "ASSIGNMENT_MEETING";
    newAssignmentModalData["createHeader"] = t("common:schedule_video_call");
    setAssignmentModalData(assignmentModalData => ({
      ...assignmentModalData,
      ...newAssignmentModalData,
    }));
    setScheduleEventModal(true);
  };
  const onAssesmentEdit = ({ item }) => {
    setCurriculumProgramContextForCCH();
    setAssignmentModalData({
      mode: "edit",
      assignment: item,
    });
  };

  // * Explicitly resetting curriculum program context when component unmount
  useEffect(() => {
    return () => {
      resetCurriculumProgramContextForCCH();
    };
  }, [resetCurriculumProgramContextForCCH]);

  useEffect(() => {
    if (mode === "edit") {
      const { id, eventId, contentType, itemType, item } = editModeDetails;
      if (itemType === "CALENDAR_EVENT_ITEM") {
        onCalendarItemEdit({ eventId });
      } else {
        onAssesmentEdit({ id, contentType, item });
      }
    }
    if (dropdownButtonRef && dropdownButtonRef.current) {
      // this is to open the dropdown when the user clicks on any tile in the calendar
      dropdownButtonRef.current.click();
      setSelectedSlotClicked(true);
    }
  }, []);

  useEffect(() => {
    if (isCalendarDeadlineView) {
      onCreateProjectDeadline();
    }
  }, []);

  const onCloseNewDeadlineModal = () => {
    setShowNewDeadlineModal(false);
    onOverlayClickClose && onOverlayClickClose();
  };

  const overlayClasses = classNames(
    { [classes.overlay]: !openedFromHeader },
    { [classes.overlayTransparent]: openedFromHeader },
    {
      [classes.overlayV2]: isNewEventCreationFlowFFEnabled && !openedFromHeader,
    }
  );

  const { startDate, startTime } = selectedTimeSlot || {};
  const finalOptions = clonedOptions;

  useEffect(() => {
    if (setSlotDropdown) {
      setSlotDropdown(prevSlotDropdownState => ({
        ...prevSlotDropdownState,
        isHeaderCreateDropdownButtonEnabled: !_.isEmpty(finalOptions),
      }));
    }
  }, []);

  /* 
    From calendar header we change the dropdown placement to bottomRight, 
    reversing this so default always remains bottomLeft unless specified otherwise
  */
  useEffect(() => {
    return () => {
      if (_.isFunction(setSlotDropdown)) {
        setSlotDropdown(prevSlotDropdownState => ({
          ...prevSlotDropdownState,
          dropdownPlacement: "right",
        }));
      }
    };
  }, []);
  const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false);
  const isFormUpdated = useIsEventFormUpdated(selectedTimeSlot);
  const isVideoMeetingFormUpdated = useIsVideoMeetingFormUpdated();

  // Handling overlay click when video meeting modal is open
  const videoMeetingOverlayClick = domEvent => {
    if (isNewVideoMeetingUIEnabled) {
      if (!isVideoMeetingFormUpdated && onOverlayClickClose) {
        onOverlayClickClose(domEvent);
        return;
      }

      setIsConfirmationModalOpen(true);
    }
  };
  const overlayClick = domEvent => {
    // Handling overlay click when event creation modal is open
    if (
      (!isNewEventCreationFlowFFEnabled || !isVisible || !isFormUpdated) &&
      onOverlayClickClose
    ) {
      onOverlayClickClose(domEvent);
      return;
    }

    setIsConfirmationModalOpen(true);
  };
  const onDiscardChanges = () => {
    setIsConfirmationModalOpen(false);
    onOverlayClickClose && onOverlayClickClose();
    resetEventModalV2();
  };
  const onKeepChanges = () => {
    setIsConfirmationModalOpen(false);
  };
  const isNewVideoMeetingUIEnabled = isNewVideoMeetingUIFeatureEnabled();
  const VideoMeetingModal = isNewVideoMeetingUIEnabled ? (
    <Popover
      isOpen={true}
      align={"center"}
      positions={["right", "left", "bottom", "top"]}
      boundaryInset={20}
      padding={12}
      reposition={true}
      containerStyle={{
        zIndex: 1002,
      }}
      key={slotDropdown}
      content={
        <VideoMeetingCreationModal
          selectedTimeSlot={selectedTimeSlot ? selectedTimeSlot : {}}
          isAllDayEvent={false}
          showAllDayCheckbox={false}
          onCloseEventCreationModal={onCloseVideoMeetingModal}
          showModal={emptyStateCreate}
          mode={assignmentModalData["mode"]}
          openedFromHeader={openedFromHeader}
          testId={`${testId}-videoMeetingCreationModal`}
        />
      }
      contentLocation={setPopoverModalContentLocation}
      childrenRef={{ current: document.querySelector(`#${slotId}`) }}
      isChildrenRefPassed={true}
    ></Popover>
  ) : (
    <UIModal
      isOpen={true}
      isFullScreen={true}
      overlayContainer={classes.assignmentModalOverlay}
      showFromTopOfTheViewPort={true}
    >
      <ScheduleEvent
        courseId={assignmentModalData["courseId"]}
        mode={assignmentModalData["mode"]}
        assignmentId={assignmentModalData["id"]}
        createHeader={assignmentModalData["createHeader"]}
        eventId={assignmentModalData["eventId"]}
        onClickDiscard={onCloseAddAssignmentModal}
        selectedTimeSlot={selectedTimeSlot ? selectedTimeSlot : {}}
        showAddClassButton={true}
        preSelectedCourseIds={_.compact(preSelectedCourseIds)}
        userCourses={courseList}
        testId={`${testId}-scheduleEvent`}
      />
    </UIModal>
  );
  return (
    <>
      {mode === "create" && !isCalendarDeadlineView ? (
        <>
          <ConformationModal
            isConfirmationModalOpen={isConfirmationModalOpen}
            t={t}
            onCancelDiscardingChanges={onKeepChanges}
            onDiscardingChanges={onDiscardChanges}
          />
          {showOverlay && (
            <div
              className={overlayClasses}
              onClick={
                showScheduleEventModal && isNewVideoMeetingUIEnabled
                  ? videoMeetingOverlayClick
                  : overlayClick
              }
            ></div>
          )}
          <Dropdown
            overlay={
              <DropdownMenu
                dsVersion={isGlobalHeaderEnabled ? "2.0" : "1.0"}
                options={finalOptions}
                onClick={onDropdownItemClick}
                testId={`${testId}-create`}
              />
            }
            placement={_.get(slotDropdown, "dropdownPlacement")}
          >
            {buttonComponent ? (
              buttonComponent
            ) : (
              <div
                ref={dropdownButtonRef}
                style={btnDropdownStyles.parentContainerStyle}
                className={selectedSlotClasses}
                id={slotId}
                onClick={selectedSlotClicked ? onOverlayClickClose : null}
              />
            )}
          </Dropdown>
        </>
      ) : null}

      {/* !showScheduleEventModal condition  is added because setAssignmentModalData is callend in "SCHEDULE_VIDEO_CALL"
       case which sets data but this need to only run in case of assignment create or edit */}
      {!_.isEmpty(assignmentModalData) && !showScheduleEventModal ? (
        <CreateOrEditAssignment
          mode={assignmentModalData.mode}
          createAssignmentData={assignmentModalData.createAssignmentData}
          assignment={assignmentModalData.assignment}
          course={course}
          courseId={courseId}
          selectedCourseIdInCalendar={_.first(preSelectedCourseIds)}
          courseList={courseList}
          isMultipleCoursesSelectedInCalendar={preselectedCoursesLength > 1}
          selectedTimeSlot={selectedTimeSlot ? selectedTimeSlot : {}}
          creationSource={"CALENDAR"}
          onClose={onCloseAddAssignmentModal}
          onClickAssessmentDraftCloseButton={onCloseAssessmentDraftModal}
          overlayContainer={classes.assignmentModalOverlay}
        />
      ) : null}

      {showScheduleEventModal ? VideoMeetingModal : null}
      {showNewDeadlineModal ? (
        <DSProvider dsVersion="2.0">
          <CreateCalendarDeadlineModal
            overlayContainer={classes.assignmentModalOverlay}
            onClose={onCloseNewDeadlineModal}
            eventType={eventType}
            t={t}
            refetchEvents={refetchEvents}
            eventDetailsProps={
              startTime && startDate
                ? {
                    dueOn: moment(`${startDate} ${startTime}`),
                  }
                : {}
            }
            testId={`${testId}-createCalendarDeadlineModal`}
          />
        </DSProvider>
      ) : null}

      {isVisible &&
        (!isNewEventCreationFlowFFEnabled ? (
          <EventCreationModal
            action={action}
            eventType={eventType}
            selectedTimeSlot={selectedTimeSlot ? selectedTimeSlot : {}}
            onCloseEventCreationModal={onCloseEventCreationModal}
            testId={`${testId}-eventCreationModal`}
          />
        ) : (
          <Popover
            isOpen={true}
            align={"center"}
            positions={["right", "left", "bottom", "top"]}
            boundaryInset={20}
            padding={12}
            key={slotDropdown}
            reposition={true}
            containerStyle={{
              zIndex: 1002,
            }}
            content={
              <EventCreationModalV2
                onCloseEventCreationModal={onCloseEventCreationModal}
                showModal={emptyStateCreate}
                createEventContainerClass={createEventContainerClass}
                mode={mode}
                openedFromHeader={openedFromHeader}
                selectedTimeSlot={selectedTimeSlot ? selectedTimeSlot : null}
                refetchEvents={refetchEvents}
                refetchAssignedData={refetchAssignedData}
                testId={`${testId}-eventCreationModalV2`}
              />
            }
            contentLocation={setPopoverModalContentLocation}
            childrenRef={{
              current: document.querySelector(`#${slotId}`),
            }}
            isChildrenRefPassed={true}
          ></Popover>
        ))}
    </>
  );
});

EditOrCreateEvent.displayName = "EditOrCreateEvent";

EditOrCreateEvent.propTypes = {
  mode: PropTypes.oneOf(["create", "edit"]),
  showOverlay: PropTypes.bool,
  onOverlayClickClose: PropTypes.func,
  showDropdown: PropTypes.bool,
  buttonComponent: PropTypes.element,
  btnDropdownStyles: PropTypes.object,
  selectedTimeSlot: PropTypes.object,
  refetchEvents: PropTypes.func,
  refetchRotationDays: PropTypes.func,
  calendarEventModalClose: PropTypes.func,
  editModeDetails: PropTypes.object,
};

EditOrCreateEvent.defaultProps = {
  mode: "create",
  showOverlay: false,
  showDropdown: false,
  onOverlayClickClose: null,
  refetchEvents: null,
  refetchRotationDays: null,
  calendarEventModalClose: null,
};

const mapStateToProps = (state, ownProps) => {
  const { course, openedFromHeader, selectedTimeSlot, courseList } = ownProps;

  const userInfo = getUserInfo(state);
  const { org_id: organizationId } = userInfo;

  const selectedAcademicYear = getSelectedAcademicYearForSchool(state);
  const subjectType = _.get(course, "subjects.0.type", "");
  const academicYearId = selectedAcademicYear?.id;

  const gradeId = _.get(state, "teacher.selected_class.selected_grades[0]", "");
  let globalGradeUid;
  if (gradeId) {
    const gradeDetails = getGradeBasicDetailsFromCache(gradeId);
    globalGradeUid = _.get(gradeDetails, "globalGrade.uid", null);
  }

  const { currentCurriculumProgramId } = getSelectedSchoolDetailsForCalendar(
    state
  );
  const currentCurriculumProgramType = getCurrentCurriculumProgramType(state);

  const isDpCurriculum = _.isEqual(
    currentCurriculumProgramType,
    CURRICULUM_TYPE_DP
  );

  const selectedAcademicYearStartDate = getSelectedAcademicYearStartDate({
    selectedAcademicYear,
  });
  const selectedAcademicYearEndDate = getSelectedAcademicYearEndDate({
    selectedAcademicYear,
  });

  const finalSelectedTimeSlot = openedFromHeader
    ? getNextThirtyMinuteSlot()
    : selectedTimeSlot;

  const projectGroupCategoryIdByType = getProjectGroupCategoryIdByType({
    curriculumProgramIds: currentCurriculumProgramId
      ? [currentCurriculumProgramId]
      : [],
    organizationId,
    curriculumType: currentCurriculumProgramType,
  });

  const tags = _.get(state, "myCalendar.schoolCalendarTags");
  const canCreateEventUsingAdminTag = isStaffAdminForSchoolCalendarByContext({
    contexts: [
      {
        entityId: currentCurriculumProgramId,
        entityType: "CURRICULUM_PROGRAM",
      },
    ],
  });
  const canUserCreateEvent = canUserCreateEventOnCalendar({
    isStaffSchoolCalendarAdmin: canCreateEventUsingAdminTag,
    currentCurriculumProgramId,
    courseList,
  });

  const userCurriculumPrograms = getUserCurriculumPrograms();

  return {
    subjectType,
    projectGroups: getProjectGroups(
      state,
      isStaffAdminForProjectModules({
        projectGroupCategoryIdByType,
        curriculumProgramId: currentCurriculumProgramId,
      })
    ),
    calendarView: _.get(state, "myCalendar.calendarView"),
    academicYearId,
    globalGradeUid,
    isDpCurriculum,
    selectedAcademicYearStartDate,
    selectedAcademicYearEndDate,
    selectedTimeSlot: finalSelectedTimeSlot,
    projectGroupCategoryIdByType,
    curriculumProgramId: currentCurriculumProgramId,
    eventTypeList: getFilteredEventTypes({
      tags,
      canCreateEventUsingAdminTag: canUserCreateEvent,
    }),
    userCurriculumPrograms,
  };
};

const mapActionCreators = {
  getOptionsForDropdown,
  setAiModuleMarketingKey,
  resetEventModalV2,
  setupCurriculumProgramDependencies,
};

export default compose(
  I18nHOC({ resources: ["common", "classRoom", "calendar"] }),
  connect(mapStateToProps, mapActionCreators)
)(EditOrCreateEvent);
